<template>
<div>
  <div v-if="$store.state.users.auth" class="big-screens-top-bar fl-page-bar" style="">
    <div class="fl-page-bar-container top-bar-container container">
      <div class="fl-page-bar-row row">
        <div class="col-md-6 col-lg-6 text-left clearfix">
        </div>			
        <div class="col-md-6 col-lg-6 text-right clearfix">		
          <nav class="top-bar-nav" aria-label="Top Bar Menu" itemscope="itemscope" itemtype="https://schema.org/SiteNavigationElement" role="navigation">
            <ul id="menu-top-menu" class="fl-page-bar-nav nav navbar-nav menu">
              <li v-if="$store.state.users.auth" id="menu-item-148" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-148 nav-item"><div class="desktop-topbar-item"><span class="welcome">Welcome, </span><router-link :to="{ name: 'Profile' }" class="nav-link" > {{ $store.state.users.user.first_name }}</router-link> </div> </li>
              <!-- <li v-if="$store.state.auth" id="menu-item-148" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-148 nav-item"><router-link :to="{ name: 'Profile' }" class="nav-link" > My Account</router-link></li> -->
              <li v-if="$store.state.users.auth" id="menu-item-150" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-150 nav-item"><router-link :to="{ name: 'MyTrips' }" class="nav-link">My Trips</router-link></li>
              <!-- <li v-if="$store.state.auth" id="menu-item-151" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-151 nav-item"><router-link :to="{ name: 'ConversationsList' }" class="nav-link">Conversations</router-link></li> -->
              <li v-if="$store.state.users.auth" id="menu-item-152" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item"><button class="nav-link" @click="logout" href="#">Logout</button></li>
              <!-- <li v-if="!$store.state.users.auth" id="menu-item-154" class="pt-5 pb-5 menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item"><router-link class="nav-link" to="/login">Login</router-link></li> -->
              <li v-if="!$store.state.users.auth" id="menu-item-153" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item"><router-link class="nav-link" to="/signin">Join</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div v-if="guestEmail && !$store.state.users.auth" class="big-screens-top-bar fl-page-bar" style="">
    <div class="fl-page-bar-container top-bar-container container">
      <div class="fl-page-bar-row row">
        <div class="col-md-6 col-lg-6 text-left clearfix">
        </div>			
        <div class="col-md-6 col-lg-6 text-right clearfix">		
          <nav class="top-bar-nav" aria-label="Top Bar Menu" itemscope="itemscope" itemtype="https://schema.org/SiteNavigationElement" role="navigation">
            <ul id="menu-top-menu" class="fl-page-bar-nav nav navbar-nav menu">
              <li id="menu-item-148" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-148 nav-item"><div class="desktop-topbar-item"><span class="welcome">Welcome {{ guestEmail }}</span> </div> </li>
              <li id="menu-item-152" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item"><button class="nav-link" @click="guestLogout" href="#">Not you?</button></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>


  <div class="small-screens-top-bar fl-page-bar">
    <div class="fl-page-bar-container top-bar-container container">
      <div class="fl-page-bar-row row">
        <div class="col-md-6 col-lg-6 text-left clearfix"></div>			
        <div class="col-md-6 col-lg-6 clearfix d-flex flex-row justify-content-center align-items-center p-0">		
            <!-- <ul id="menu-top-menu" class="fl-page-bar-nav nav navbar-nav menu d-flex flex-row align-items-center"> -->
              <!-- <li id="menu-item-155" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item">
                <router-link class="nav-link" to="/trip/search">
                  <i class="fas fa-search">
                  </i>
                </router-link>
              </li> -->
              <div v-if="guestEmail" id="menu-item-14" class="w-100 d-flex topbar-mobile-element menu-item menu-item-type-post_type menu-item-object-page menu-item-148 nav-item">
                <!-- <div style="vertical-align: top; display: inline-block; text-align: center; width: 60px;"> -->
                      <div>Welcome, {{guestEmail}}</div>
                      <div id="menu-item-152" class=""><button class="nav-link-mobile" @click="guestLogout" href="#">Not you?</button></div>
                <!-- </div> -->
              </div>
              <!-- <li id="menu-item-155" class="topbar-mobile-element menu-item menu-item-type-custom menu-item-object-custom nav-item">
                <div style="vertical-align: top; display: inline-block; text-align: center; width: 60px;">
                  <router-link class="nav-link" to="/trip/search">
                    <i class="fas fa-search"></i>
                  </router-link>
                  <div style="display: block;">
                    <router-link class="nav-link" to="/trip/search">
                      <span>Search</span>
                    </router-link>
                  </div>
                </div>
              </li> -->
              
              <li v-if="$store.state.users.auth" id="menu-item-148" class="topbar-mobile-element menu-item menu-item-type-post_type menu-item-object-page menu-item-148 nav-item">
                <div style="vertical-align: top; display: inline-block; text-align: center; width: 60px;">
                  <router-link class="nav-link" :to="{ name: 'Profile' }">
                    <i class="fas fa-user"></i>
                  </router-link>
                  <div style="display: block;">
                    <router-link class="nav-link" :to="{ name: 'Profile' }">
                      <span>My Profile</span>
                    </router-link>
                  </div>
                </div>
              </li>
              <!-- <li v-else id="menu-item-155" class="topbar-mobile-element menu-item menu-item-type-custom menu-item-object-custom nav-item">
                <div style="vertical-align: top; display: inline-block; text-align: center; width: 60px;">
                  <router-link class="nav-link" to="/login">
                    <i class="fas fa-users"></i>
                  </router-link>
                  <div style="display: block;">
                    <router-link class="nav-link" to="/login">
                      <span>Login</span>
                    </router-link>
                  </div>
                </div>
              </li> -->
              <li v-if="$store.state.users.auth" id="menu-item-150" class="topbar-mobile-element menu-item menu-item-type-custom menu-item-object-custom menu-item-150 nav-item">
                <div style="vertical-align: top; display: inline-block; text-align: center; width: 60px;">
                  <router-link class="nav-link" :to="{ name: 'MyTrips' }">
                    <i class="fas fa-plane"></i>
                  </router-link>
                  <div style="display: block;">
                    <router-link class="nav-link" :to="{ name: 'MyTrips' }">
                      <span>My Trips</span>
                    </router-link>
                  </div>
                </div>
              </li> -->
              <!-- <li v-if="$store.state.users.auth" id="menu-item-152" class="topbar-mobile-element menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item">
                <button class="nav-link" @click="logout" href="#">
                  <i class="fas fa-sign-out-alt"></i>
                </button>
              </li> -->
              <li v-if="$store.state.users.auth" id="menu-item-154" class="pt-5 pb-5 menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item">
                <a href="/logout" class="nav-link blue-button" v-on:click.prevent="logout($event)"> Logout</a>
              </li>
              <!-- <li v-if="!$store.state.users.auth" id="menu-item-154" class="pt-5 pb-5 menu-item menu-item-type-custom menu-item-object-custom menu-item-152 nav-item">
                <router-link class="nav-link blue-button" to="/signin"> Become a Member</router-link>
              </li> -->
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import httpClient from '@/utils/httpClient'
import { mapActions } from 'vuex'


export default {
  props:{
    guestEmail:{
      default:null
    }
  },
  mounted() {
    if (localStorage.getItem('guest_email')) {
      //this.setGuestEmail(localStorage.getItem('guest_email'))
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch('users/logout');
      this.$store.dispatch('guests/removeData')
      return window.top.location.href = process.env.VUE_APP_HOME_PAGE;
    },
    ...mapActions({
      setGuestEmail: 'guests/setEmail',
      removeGuestData: 'guests/removeData'
    }),
    guestLogout () {
      httpClient.get('/logout',null).then(() => this.logout())
    }
  }
}
</script>


<style>

.fl-page-bar {
  border-bottom: 1px solid #e6e6e6;
  border-bottom-color: rgb(230, 230, 230);
  font-size: 12px;
  line-height: 14px;
  border-color: #2642aa;
  background-color: #1a2d74;
  color: #fff;
}

button.nav-link {
  background: none!important;
  border: none;
  padding: 15px 0px 15px 15px;
  color:#fff;
  cursor: pointer;
  font-family: "Work Sans",sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.4;
  text-transform: none;
  
}

.fl-page-bar .navbar-nav li > a {
    color: #fff;
}

.fl-page-bar nav {
    display: inline-block;
}

.top-bar-container {
  width: 1440px;
  max-width: 90%;
}

ul.fl-page-bar-nav {
    display: inline-block;
    text-align: right;
    vertical-align: middle;
}

.fl-page-bar-nav > li {
    display: inline-block;
    float: none;
    position: relative;
}

.fl-page-bar-nav > li > a.nav-link,
.fl-page-bar-nav > li > button.nav-link,
.desktop-topbar-item, 
.desktop-topbar-item a.nav-link{
    padding: 2px 10px;
    color: #fff;
    font-size: 18px;
    font-weight: 300;
}

.desktop-topbar-item {
  display: flex;
  flex-flow: row;
  align-items: baseline;
}

.desktop-topbar-item a.nav-link:hover,
.fl-page-bar-nav > li > button.nav-link:hover{
  color: #2597d8;
}

.nav-link-mobile {
  background: none!important;
  border: none;
  padding: 15px 0px 15px 15px;
  color:#fff;
  cursor: pointer;
  font-family: "Work Sans",sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  text-transform: none;
}

@media (min-width: 661px) {
  .big-screens-top-bar {
    display: block;
  }
  .small-screens-top-bar {
    display:none
  }
}


@media (max-width: 660px) {
  .big-screens-top-bar {
    display: none;
  }
  .small-screens-top-bar {
    display: block;
  }
  #menu-item-154 a.blue-button,
  p.blue-button {
    color: #fff;
    font-weight: 700;
    font-size: 10px;
    background: #428bca;
    border-radius: 4px;
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    line-height: 18px;
    padding: 2px 12px;
    text-decoration: none;
    text-shadow: none;
    text-align: center;
    margin-top: 2px;
    margin-bottom: 4px;
  }

  .topbar-mobile-element {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    width: 60px;
  }
  .topbar-mobile-element a {
    padding: 0;
    color: #fff;
    font-size: 10px !important;
  }

  .topbar-mobile-element a:hover {
    text-decoration: underline;
  }
}

</style>
